module.exports = __webpack_public_path__ + "/images/ico-primary-hucha.267c3da.svg";